type FieldErrorProps = {
  error?: string;
};

export default function FieldError({ error }: FieldErrorProps) {
  if (!error) {
    return null;
  }

  return <p className="field-error">{error}</p>;
}
